<template>
  <div class="grid">
    <div class="grid-title">
      <h4>{{ $t("HOTEL_REGISTER_INFO") }}</h4>
      <v-btn color="primary" class="pl-10 pr-10" @click="save">{{ $t("SAVE") }}</v-btn>
    </div>
    <div class="grid-body p-3 border-top-unset" v-if="!loading">
      <v-form ref="formInfo" lazy-validation>
        <v-row>
          <v-col sm="6" class="py-2">
            <label class="label-input">{{ $t("HOTEL_CODE") }}</label>
            <v-text-field type="text" outlined dense disabled v-model="data.id" />
          </v-col>
          <v-col sm="3" class="py-2">
            <label class="label-input">{{ $t("WEBSITE") }}</label>
            <v-text-field type="text" outlined dense v-model="data.website" />
          </v-col>
           <v-col sm="3" class="py-2">
            <label class="label-input">{{ $t('CONFIG_BE') }}</label>
            <v-text-field v-model="data.beLink" outlined dense :rules="[rules.isURL]" @keydown="validateBeLink($event)"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="6" class="py-2">
            <v-row>
              <v-col sm="6" class="pt-0 pb-2">
                <label class="label-input">{{ $t("STAR_RATING") }} *</label>
                <select-text :items="select.stars" :id.sync="data.star" />
              </v-col>
              <v-col sm="6" class="pt-0 pb-2">
                <label class="label-input">{{ $t("CONTACT_PHONE") }} *</label>
                <div>
                  <vue-tel-input class="input-tel" :class="phone.valid ? '' : 'border-danger'" v-model="phone.number"
                    @input="onInput" :valid-characters-only="true" :preferredCountries="['vn']" :inputOptions="{
                      placeholder: $t('CONTACT_PHONE')
                    }" :dropdownOptions="{
  showFlags: true,
  showSearchBox: true,
  showDialCodeInList: true
}"></vue-tel-input>
                </div>
              </v-col>
              <v-col sm="6" class="pt-4 pb-2">
                <label class="label-input">{{ $t("HOTEL_TYPE") }} *</label>
                <select-text :items="select.hotelTypes" :id.sync="data.hotelType" />
              </v-col>
              <v-col sm="6" class="pt-4 pb-2">
                <label>{{ $t("UTC") }} *</label>
                <treeselect class="utc" name="utc" instanceId="utc" :options="optionUTC" :default-expand-level="1"
                  :placeholder="$t('UTC')" :disable-branch-nodes="true" :required="errors.timeZoneStr.error"
                  v-model="data.timeZoneStr" :class="data.timeZoneStr ? '' : 'border-danger'" />
              </v-col>
            </v-row>
          </v-col>
          <v-col sm="4" class="py-2">
            <v-row>
              <v-col sm="12" class="cursor py-0">
                <label class="label-input">{{ $t("HOTEL_LOGO") }}</label>
                <div v-if="data.logo && !data.logo.id" id="upload-controller" class="relative" @click="upload">
                  <div class="container">
                    <!--UPLOAD-->
                    <form enctype="multipart/form-data" novalidate>
                      <div class="dropbox">
                        <span class="icon-upload"></span>
                      </div>
                    </form>
                  </div>
                </div>
                <div v-if="data.logo && data.logo.id" class="relative logo-box">
                  <img :src="data.logo.url" alt width="100%" />
                  <div class="mask">
                    <span class="icon-upload" @click="upload"></span>
                    <span class="icon-delete-ic" @click="data.logo = {}; data.logoId = null" />
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!-- <v-row>
          
        </v-row> -->
        <v-divider class="mb-3"></v-divider>
        <v-row>
          <v-col sm="6" class="py-2">
            <label class="label-input">{{ $t("COUNTRY") }} *</label>
            <v-autocomplete v-model="country" :items="select.countries" outlined dense item-text="value" item-value="id"
              label="" :rules="[rulesMap.required]"></v-autocomplete>
          </v-col>
          <v-col sm="6" class="py-2">
            <label class="label-input">{{ $t("CITY") }} *</label>
            <v-autocomplete v-model="city" :items="select.cities" outlined dense item-text="value" item-value="id"
              label="" :rules="[rulesMap.required]"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="6" class="py-2 mb-4">
            <label class="label-input">{{ $t("DISTRICT") }} *</label>
            <v-autocomplete v-model="district" :items="select.districts" outlined dense item-text="value" item-value="id"
              label="" :rules="[rulesMap.required]"></v-autocomplete>
          </v-col>
          <v-col sm="6" class="py-2 mb-4">
            <label class="label-input">{{ $t("WARD") }}</label>
            <v-autocomplete v-model="ward" :items="select.wards" outlined dense item-text="value" item-value="id"
              label=""></v-autocomplete>
          </v-col>
        </v-row>
        <v-divider class="mb-0"></v-divider>
        <!-- <v-row>
          <v-col sm="8">
            <v-tabs v-model="tab" class="pl-0">
              <v-tab class="text-center">{{ $t("VIETNAMESE") }}</v-tab>
              <v-tab class="text-center">{{ $t("ENGLISH") }}</v-tab>
            </v-tabs>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="6" class="py-2">
            <label class="label-input">{{ $t("HOTEL_NAME") }} *</label>
            <v-text-field v-model="data.i18ns.find(x => x.lang == langTab).name" outlined dense counter maxlength="250"
              class="input-counter" :rules="ruleName"></v-text-field>
          </v-col>
          <v-col sm="6" class="py-2">
            <label class="label-input">{{ $t("ADDRESS") }} *</label>
            <v-text-field v-model="data.i18ns.find(x => x.lang == langTab).address" outlined dense
              :rules="ruleName"></v-text-field>
          </v-col>
          <v-col sm="12" class="py-2 mb-4">
            <label class="label-input">{{ $t("DESCRIPTION_INFO") }}</label>
            <v-textarea :rows="6" v-model="data.i18ns.find(x => x.lang == langTab).description" outlined counter="3000"
              maxlength="3000" class="input-counter" :rules="ruleDescNotRequired" dense></v-textarea>
          </v-col>
        </v-row> -->
        <v-tabs v-model="tab" class="pl-0">
          <v-tab>{{ $t("DEFAULT") }}</v-tab>
          <v-tab v-for="name in languages" :key="name">{{ name }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-row>
              <v-col sm="12" class="pb-0">
                <label>{{ $t("HOTEL_NAME") }} *</label>
                <v-text-field v-model="data.nameVi" outlined dense :rules="ruleName" counter maxlength="250"
                  class="input-counter" v-on:keyup="updateTitle(data.nameVi)"></v-text-field>
              </v-col>
              <v-col sm="12" class="pb-0">
                <label>{{ $t("DESCRIPTION_INFO") }}</label>
                <v-textarea :rows="6" v-model="data.descriptionVi" outlined dense counter="3000" maxlength="3000"
                  :rules="ruleDescNotRequired" class="input-counter"
                  v-on:keyup="updateDescription(data.descriptionVi)"></v-textarea>
              </v-col>
            </v-row>
          </v-tab-item>
          <!-- start -->
          <v-tab-item v-for="code in codeLangs" :key="code">
            <v-row>
              <v-col sm="6" class="pb-0">
                <label>{{ $t("HOTEL_NAME") }} *</label>
                <v-text-field v-model="data.i18ns.find(x => x.lang == code).name" outlined dense counter maxlength="250"
                  class="input-counter" :rules="ruleName"></v-text-field>
              </v-col>
              <v-col sm="6" class="pb-0">
                <label class="label-input">{{ $t("ADDRESS") }} *</label>
                <v-text-field v-model="data.i18ns.find(x => x.lang == code).address" outlined dense
                  :rules="ruleName"></v-text-field>
              </v-col>
              <v-col sm="12" class="pb-0">
                <label>{{ $t("DESCRIPTION_INFO") }}</label>
                <v-textarea :rows="6" v-model="data.i18ns.find(x => x.lang == code).description
                  " outlined dense counter="3000" maxlength="3000" class="input-counter"
                  :rules="ruleDescNotRequired"></v-textarea>
              </v-col>
            </v-row>
          </v-tab-item>
          <!-- end -->
          <!-- <v-tab-item>
            <v-row>
              <v-col sm="6" class="pb-0">
                <label>{{ $t("HOTEL_NAME") }} *</label>
                <v-text-field v-model="data.i18ns.find(x => x.lang == 'vi').name" outlined dense counter maxlength="250"
                  class="input-counter" :rules="ruleName"></v-text-field>
              </v-col>
              <v-col sm="6" class="pb-0">
                <label class="label-input">{{ $t("ADDRESS") }} *</label>
                <v-text-field v-model="data.i18ns.find(x => x.lang == 'vi').address" outlined dense
                  :rules="ruleName"></v-text-field>
              </v-col>
              <v-col sm="12" class="pb-0">
                <label>{{ $t("DESCRIPTION_INFO") }}</label>
                <v-textarea :rows="6" v-model="data.i18ns.find(x => x.lang == 'vi').description
                  " outlined dense counter="3000" maxlength="3000" class="input-counter"
                  :rules="ruleDescNotRequired"></v-textarea>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col sm="6" class="pb-0">
                <label>{{ $t("HOTEL_NAME") }} *</label>
                <v-text-field v-model="data.i18ns.find(x => x.lang == 'en').name" outlined dense counter maxlength="250"
                  class="input-counter" :rules="ruleName"></v-text-field>
              </v-col>
              <v-col sm="6" class="pb-0">
                <label class="label-input">{{ $t("ADDRESS") }} *</label>
                <v-text-field v-model="data.i18ns.find(x => x.lang == 'en').address" outlined dense
                  :rules="ruleName"></v-text-field>
              </v-col>
              <v-col sm="12" class="pb-0">
                <label>{{ $t("DESCRIPTION_INFO") }}</label>
                <v-textarea :rows="6" v-model="data.i18ns.find(x => x.lang == 'en').description
                  " outlined counter="3000" maxlength="3000" class="input-counter" :rules="ruleDescNotRequired"
                  dense></v-textarea>
              </v-col>
            </v-row>
          </v-tab-item> -->
        </v-tabs-items>
        <v-divider class="mb-2"></v-divider>
        <v-subheader class="p-0">{{ $t("MAP_LOCATION") }}</v-subheader>
        <v-row>
          <v-col sm="5" class="py-2">
            <label class="label-input">{{ $t("LATITUDE") }} *</label>
            <v-text-field v-model="data.lat" outlined dense :rules="[rulesMap.required, rulesMap.regex, rulesMap.lat]"
              @change="changeMap" type="number"></v-text-field>
          </v-col>
          <v-col sm="5" class="py-2">
            <label class="label-input">{{ $t("LONGITUDE") }} *</label>
            <v-text-field v-model="data.lng" outlined dense :rules="[rulesMap.required, rulesMap.regex, rulesMap.lng]"
              @change="changeMap" type="number"></v-text-field>
          </v-col>
          <v-col sm="2" class="py-2">
            <label class="label-input">{{ $t("ZOOM") }} *</label>
            <v-text-field v-model="data.zoom" outlined dense type="number" @change="changeMap"
              :rules="ruleVat"></v-text-field>
          </v-col>
          <v-col sm="12" class="py-2">
            <google-map v-if="mapParams" :params.sync="mapParams" :zoom.sync="data.zoom" ref="googleMap" />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <upload-dialog :logo="logo" :isChooseOneOnly="true" :uploadDialog="uploadDialog" :uploadedFiles="uploadedFiles"
      @uploadTargetImage="uploadTargetImage" ref="uploadComponent">
      <div slot="header" class="tab-header">
        <label class="tab-title">{{ $t("LIBRARY") }}</label>
      </div>
    </upload-dialog>
  </div>
</template>
<style lang="scss" scoped>
.dropbox {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: 121px !important;

  span {
    font-size: 24px;
    color: #173d8f;
  }
}
</style>
<script>
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import UploadDialog from "@/components/Utils/UploadDialog.vue";
import GoogleMap from "@/components/Utils/GoogleMap.vue";
import { upload } from "@/_services/UploadFile/file-upload.fake.service"; // fake service
import { registerInfoService } from "@/_services/GeneralInfomation/register-infomation.service.js";
import { VueEditor } from "vue2-editor";
import { systemService } from "@/_services/system-data.service.js";
import {
  _validateFormI18n,
  _storedUserInfo,
  _alert,
  _resetErrorState
} from "@/_helpers/function.js";
import VueSingleSelect from "vue-single-select";
import {
  REGEX_PHONE,
  REGEX_EMAIL,
  REGEX_ENTERPRISE_CODE,
  REGEX_NUMBER,
  REGEX_DISTANCE
} from "@/_helpers/constant.js";
import { RI_ERROR } from "@/_helpers/config.js";
import { setTimeout } from "timers";
import Textarea from "@/components/Utils/Textarea.vue";

import { optionUTC } from "@/_helpers/globalData.js";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import store from "@/plugins/store";
export default {
  components: {
    "upload-dialog": UploadDialog,
    "input-text": Input,
    "select-text": Select,
    "google-map": GoogleMap,
    VueSingleSelect,
    VueEditor,
    "input-textarea": Textarea,
    Treeselect
  },
  created() {
    this.initialize();
    _resetErrorState(this.errors);
    this.select.stars = [
      { id: 0, value: this.$t("NO_RANK") },
      { id: 1, value: this.$t("ONE_STAR") },
      { id: 2, value: this.$t("TWO_STAR") },
      { id: 3, value: this.$t("THREE_STAR") },
      { id: 4, value: this.$t("FOUR_STAR") },
      { id: 5, value: this.$t("FIVE_STAR") }
    ];
  },
  mounted() {
    document
      .querySelector(".v-tab.v-tab--active")
      .classList.remove("v-tab--active");
    document
      .querySelector(".v-tab[tabIndex='0']")
      .classList.add("v-tab--active");
  },
  data() {
    return {
      loading: true,
      optionUTC: optionUTC(),
      data: {},
      errors: RI_ERROR,
      uploadDialog: false,
      uploadedFiles: [],
      tab: null,
      lang: this.$i18n.locale,
      locations: [],
      country: null,
      city: null,
      district: null,
      ward: null,
      select: {
        hotelTypes: [],
        stars: [],
        countries: [],
        cities: [],
        districts: [],
        wards: []
      },
      // Mặc định địa điểm
      defaultLat: 21.027763,
      defaultLong: 105.834160,
      mapParams: null,
      logo: JSON.parse(localStorage.getItem("currentUser")).hotel
        ? JSON.parse(localStorage.getItem("currentUser")).hotel.logo
        : null,
      optionCountry: [],
      areaCode: null,
      rules: {
        required: value => !!value || this.$t('_ACCOUNT_SETTING.PHONE_NUMBER') + ' ' + this.$t('SERVICE.NOT_EMPTY'),
        counter: value => (value && value.length <= 10 && value.length >= 6) || this.$t('ERROR_PHONE_NUMBER_LENGTH'),
        phone: value => {
          const pattern = /^[1-9]{1}\d+$/
          return pattern.test(value) || this.$t('ERROR_PHONE_NUMBER_STRING')
        },
        isURL: value => this.isURL(value) || this.$t('URL_INVALID')
      },
      rulesMap: {
        required: value => !!value || this.$t('DATA_INPUT_INVALID'),
        lng: value => (value <= 180 && value >= -180) || this.$t('DATA_INPUT_INVALID'),
        lat: value => (value <= 90 && value >= -90) || this.$t('DATA_INPUT_INVALID'),
        regex: value => {
          const pattern = this.REGEX_DISTANCE
          return pattern.test(value) || this.$t('DATA_INPUT_INVALID')
        },
      },
      phone: {
        number: "",
        valid: false
      },
      languages: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.name) : [],
      codeLangs: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.languageCode) : []
    };
  },
  computed: {
    REGEX_ENTERPRISE_CODE() {
      return REGEX_ENTERPRISE_CODE;
    },
    REGEX_PHONE() {
      return REGEX_PHONE;
    },
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    },
    REGEX_DISTANCE() {
      return REGEX_DISTANCE;
    },
    // langTab() {
    //   return this.tab == 0 ? "vi" : "en";
    // },
  },
  watch: {
    mapParams: {
      handler(value) {
        this.data.lat = value.lat;
        this.data.lng = value.lng;
      },
      deep: true
    },
    // data: {
    //   handler(val) {
    //     if (val.lat || val.lng) {
    //       this.mapParams = {
    //         lat: val.lat,
    //         lng: val.lng
    //       };
    //       this.$refs.googleMap.updatelatLng({
    //         lat: val.lat,
    //         lng: val.lng,
    //         zoom: val.zoom
    //       });
    //     }
    //   },
    //   deep: true
    // },
    uploadedFiles() {
      return this.$store.state.imageGallary;
    },
    country(value) {
      // console.log(value)
      if (!value) {
        this.city = null;
        this.data.countryId = null;
        this.select.cities = [];
        return false;
      }
      this.data.countryId = value;
      this.select.cities = this.locations
        .filter(x => x.parent == value)
        .map(x => {
          return {
            id: x.id,
            value: x.i18ns.find(x => x.lang == this.defaultI18n).name
          };
        });
    },
    city(value) {
      if (!value) {
        this.data.cityId = null;
        this.select.districts = [];
        this.select.wards = [];
        this.district = null;
        this.ward = null;
        return false;
      }
      this.data.cityId = value;

      this.select.districts = this.locations
        .filter(x => x.parent == value && x.locType == 2)
        .map(x => {
          return {
            id: x.id,
            value: x.i18ns.find(x => x.lang == this.defaultI18n).name
          };
        });
      this.select.wards = this.locations
        .filter(x => x.locType == 3 && x.parent == value)
        .map(x => {
          return {
            id: x.id,
            value: x.i18ns.find(x => x.lang == this.defaultI18n).name
          };
        });
    },
    district(value) {
      if (!value) {
        this.data.locId = null;
        return false;
      }
      this.data.locId = value;
    },
    ward(value) {
      if (!value) {
        this.data.areaId = null;
        return false;
      }
      if (!this.select.wards.find(x => x.id == value)) {
        this.ward = null;
        return false;
      }
      this.data.areaId = value;
    }
  },
  methods: {
    isURL(str) {
      const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}\/?$/;
      if (str == '' || str == null) return true;
      return urlRegex.test(str);;
    },
    validateBeLink($event) {
      let key = $event.key;
      if (key === ' ') {
        $event.preventDefault();
      }
    },
    updateTitle(value) {
      if (value.length > 0) {
        for (let i = 0; i < this.data.i18ns.length; i++) {
          this.data.i18ns[i].name = value;
        }
      }
    },
    updateDescription(value) {
      for (let i = 0; i < this.data.i18ns.length; i++) {
        this.data.i18ns[i].description = value;
      }
    },
    onInput(formattedNumber, { number, valid, country }) {
      this.phone.number = number;
      this.phone.valid = valid;
    },
    changeMap() {
      this.mapParams = {
        lat: this.data.lat,
        lng: this.data.lng
      };
      this.$refs.googleMap.updatelatLng({
        lat: this.data.lat,
        lng: this.data.lng,
        zoom: this.data.zoom
      });
    },
    async initialize() {
      await systemService.getHotelTypes().then(res => {
        this.select.hotelTypes = res.data.map(x => {
          return {
            id: x.typeId,
            value: x.i18ns.find(x => x.lang == this.defaultI18n)
              ? x.i18ns.find(x => x.lang == this.defaultI18n).name
              : ""
          };
        });
      });
      await systemService.getLocations().then(res => {
        this.locations = res.data;
        this.select.countries = res.data
          .filter(x => !x.parent)
          .map(x => {
            return {
              id: x.id,
              value: x.i18ns.find(x => x.lang == this.defaultI18n)
                ? x.i18ns.find(x => x.lang == this.defaultI18n).name
                : ""
            };
          });
      });
      await registerInfoService.get().then(res => {
        this.data = res.data;
        this.country = res.data.countryId;
        this.city = res.data.cityId;
        this.district = res.data.locId;
        this.ward = res.data.areaId;
        //mark
        this.data.star = this.data.star || 0;
        this.data.hotelType = this.data.hotelType || 0;

        if (this.data.lat == null || this.data.lng == null) {
          this.mapParams = {
            lat: this.defaultLat,
            lng: this.defaultLong
          };
        } else {
          this.mapParams = {
            lat: this.data.lat,
            lng: this.data.lng
          };
        }

        if (!this.logo) {
          this.data.logo.id = null;
        }
        this.data.logoId = this.data.logo.id;
        this.phone.number = this.data.telephone;
        this.loading = false;
      });

      // await systemService.getAreaCode().then(res => {
      //   res.data.forEach(x => {
      //     if (x.phoneCode) {
      //       this.optionCountry.push( 
      //         {
      //           id: x.phoneCode,
      //           label: x.locationI18nSet.find(x => x.lang == this.lang).name,
      //           flag: 'https://static.oneinventory.com/flags/' + x.flagURL
      //         }
      //       );
      //     }
      // 	});
      //   this.optionCountry.forEach(e => {
      //     if (this.data.telephone.includes(e.id)) {
      //       this.areaCode = e.id;
      //     }
      //   });
      //   this.telephone = this.data.telephone.substring(this.areaCode.length, this.data.telephone.length);
      // });
    },
    upload() {
      this.$refs.uploadComponent.open();
    },
    uploadTargetImage(data) {
      if (data.id === -1) {
        return true;
      }
      this.data.logoId = data[0].id;
      this.data.logo = {
        id: data[0].id,
        imgDetailsUrl: data[0].detail,
        imgFullUrl: data[0].full,
        imgSmalListUrl: data[0].small,
        imgThumbUrl: data[0].thumb,
        url: data[0].img
      };
    },
    validateAndFocusTab() {
        if (!this.data.nameVi) {
            this.tab = 0;
            return;
        }

        for (let i = 0; i < this.codeLangs.length; i++) {
            const langCode = this.codeLangs[i];
            const roomLang = this.data.i18ns.find(x => x.lang === langCode);

            if (!roomLang || !roomLang.name || !roomLang.address) {
                this.tab = i + 1;
                return;
            }
        }
    },
    async save() {
      await this.validateAndFocusTab();
      await this.$nextTick();
      if (!this.$refs.formInfo.validate()) {
        this.$store.commit("alert/display", {
          message: this.$t("MISSING_FIELD"),
          error: true,
          success: false
        });
        this.$nextTick(() => {
            const el = document.querySelector(".v-messages.error--text");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        });
        return false;
        
      }
      if (!this.$refs.formInfo.validate()) return false;
      if (!this.phone.valid) {
        store.commit("alert/display", {
          message: this.$t("_VALIDATE.REQUIRED"),
          error: true,
          success: false,
        });
        return false;
      }
      this.data.telephone = this.phone.number;
      let temp = Object.assign({}, this.data);
      temp.nameVi = temp.i18ns.find(x => x.lang == "vi").name;
      temp.nameEn = temp.i18ns.find(x => x.lang == "en").name;
      temp.addressVi = temp.i18ns.find(x => x.lang == "vi").address;
      temp.addressEn = temp.i18ns.find(x => x.lang == "en").address;
      let { isValid, error } = _validateFormI18n(temp, this.errors);
      this.errors = error;
      if (this.errors.nameVi.error || this.errors.addressVi.error) {
        this.tab = 0;
        return false;
      }
      if (this.errors.nameEn.error || this.errors.addressEn.error) {
        this.tab = 1;
        return false;
      }
      if (!isValid) return false;
      let logoUrl = this.data.logo.url;
      delete this.data.logo;
      let beLink = this.data.beLink && this.data.beLink !== '' ? this.data.beLink : null;
      this.data.beLink = beLink;
      await registerInfoService.update(this.data).then(res => {
        if (res.responseCode == 0) {
          _storedUserInfo("hotel/logo", logoUrl);
          let currentUser = JSON.parse(localStorage.getItem("currentUser"));
          if (currentUser.hotel) {
            currentUser.hotel.i18ns.find(
              x => x.lang == "vi"
            ).name = this.data.i18ns.find(x => x.lang == "vi").name;
            currentUser.hotel.i18ns.find(
              x => x.lang == "en"
            ).name = this.data.i18ns.find(x => x.lang == "en").name;
          }
          localStorage.setItem("currentUser", JSON.stringify(currentUser));
          this.optionUTC.forEach(item => {
            item.children.forEach(child => {
              if (child.id === this.data.timeZoneStr) {
                localStorage.setItem("timeZoneStr", this.data.timeZoneStr);
                localStorage.setItem("GMT", child.label);
                return;
              }
            })
          })
          
          if (beLink && beLink.endsWith('/')) {
            beLink = beLink.slice(0, -1);
          }
          let hotelId = this.$route.params.hotelIdParam || '';
          localStorage.setItem(`${hotelId}-beLink`, beLink);
        }
        _alert(res, this.$t(res.data));
      }).catch((error) => {
        _alert({responseCode: 1}, this.$t("ERROR"));
      });
    }
  }
};
</script>
